export default "__VITE_ASSET__mcHGAL$I__"